export const TEAM_NAME = "FOOTBALL Club";
export const FACEBOOK_PAGE = "https://www.facebook.com";
export const CONTACT_EMAIL = "ernestbies@gmail.com";
export const SERVER_API = "https://football-club-backend.onrender.com/api";
export const WEBSITE_URL_PARTNER = "https://ernestbies.com";
export const SHORT_NAME = TEAM_NAME.split(" ")[0];
export const SHORT_NAME_TEAM = TEAM_NAME.split(" ")[1];
export const TEAM_DATE = "2021";

export const MAIN_DESCRIPTION = `${TEAM_NAME} jest drużyną piłkarską założoną w ${TEAM_DATE} roku z siedzibą w X.\nZespół powstał z inicjatywy X.`;

export const TEAM_DESCRIPTION = `${TEAM_NAME} działa od ${TEAM_DATE} roku. W tym czasie rozegraliśmy wiele spotkań oraz reprezentowaliśmy barwy naszego klubu w licznych turniejach. Do każdego meczu podchodzimy z wielkim zaangażowaniem oraz szacunkiem dla przeciwnika. Obswerwujcie nasze zmagania, ponieważ to Wy - kibice - jesteście naszym głównym źródłem motywacji!`;

export const ABOUT_TEAM = `${TEAM_NAME} to drużyna piłkarska powstała w ${TEAM_DATE} roku z siedzibą w X. Zespół powstał z inicjatywy X. Drużyna składa się głównie z młodych chłopaków z naszego regionu. Bierzemy udział w turniejach odbywających się na hali, jak i na orlikach. Łączy nas wspólne hobby, pasja oraz radość z rywalizowania na boiskach. Naszym marzeniem jest przystąpienie do rozgrywek B Klasy.`;

export const MAIN_IMAGE_CAPTION = `Zespół ${TEAM_NAME}, Liga Orlikowa, 21/07/2021`;

export const ABOUT_US = `${TEAM_NAME} działa od ${TEAM_DATE} roku. Od tego czasu w naszych szeregach zagrało sporo zawodników, którym zawdzięczamy wszystkie nasze sukcesy. Poznaj bliżej naszą drużynę - bo to właśnie dzięki nim - możemy spełniać nasze marzenia!`;

export const PARTNERS_DESCRIPTION =
    "Razem staramy się rozwijać nasz zespół.\nZapoznaj się z naszymi partnerami biznesowymi.";
